__turbopack_context__.v({
  "active": "f7ufzW_active",
  "dropdownArrow": "f7ufzW_dropdownArrow",
  "ebbMenu": "f7ufzW_ebbMenu",
  "emptyColumn": "f7ufzW_emptyColumn",
  "hasSubmenu": "f7ufzW_hasSubmenu",
  "megaMenu": "f7ufzW_megaMenu",
  "megaMenuChild": "f7ufzW_megaMenuChild",
  "megaMenuChildren": "f7ufzW_megaMenuChildren",
  "megaMenuColumn": "f7ufzW_megaMenuColumn",
  "megaMenuGroup": "f7ufzW_megaMenuGroup",
  "megaMenuGroupHeader": "f7ufzW_megaMenuGroupHeader",
  "megaMenuInner": "f7ufzW_megaMenuInner",
  "megaMenuRow": "f7ufzW_megaMenuRow",
  "menuBackdrop": "f7ufzW_menuBackdrop",
  "menuChevron": "f7ufzW_menuChevron",
  "menuColumn": "f7ufzW_menuColumn",
  "menuIcon": "f7ufzW_menuIcon",
  "menuItem": "f7ufzW_menuItem",
  "menuItemContent": "f7ufzW_menuItemContent",
  "menuLink": "f7ufzW_menuLink",
  "menuOpen": "f7ufzW_menuOpen",
  "nestedMenuItem": "f7ufzW_nestedMenuItem",
  "nestedMenuItemContainer": "f7ufzW_nestedMenuItemContainer",
  "nestedSubMenu": "f7ufzW_nestedSubMenu",
  "subMenu": "f7ufzW_subMenu",
  "subMenuItem": "f7ufzW_subMenuItem",
  "subMenuItemContainer": "f7ufzW_subMenuItemContainer",
});
